import React from 'react';
import { twMerge } from 'utilities/src/twMerge';
import IconComponent, { IIconsProps } from '../Icon';
import type { BreadcrumbsItemType } from '.';
import ItemConditionalWrapper from './ItemConditionalWrapper';
import useBreadcrumbsTheme from './themes';

interface BreadcrumbItemProps extends BreadcrumbsItemType {
  Icon: IIconsProps['Icon'];
  iconName: IIconsProps['iconName'];
  iconClasses?: string;
  active?: boolean;
  anchorClasses?: string;
  labelClasses?: string;
}

export default function BreadcrumbItem({
  anchorClasses,
  label,
  href,
  Icon,
  iconClasses,
  active,
  labelClasses,
  iconName,
}: BreadcrumbItemProps) {
  const { linkContainerClasses, breadcrumbActiveClasses, breadcrumbsCenterIcon, breadcrumbTextOpt } =
    useBreadcrumbsTheme();

  const classActive = twMerge({ [breadcrumbActiveClasses]: active }, breadcrumbsCenterIcon);
  const isIcon = !!Icon || !!iconName;
  return (
    <ItemConditionalWrapper href={href} itemID={href || label} className={anchorClasses}>
      <span className={classActive} data-span>
        {isIcon ? (
          <span className={breadcrumbsCenterIcon}>
            <span className={linkContainerClasses}>
              <IconComponent
                Icon={Icon}
                iconName={iconName}
                size="IconM"
                options={{ className: iconName ? undefined : iconClasses }}
                className={iconName ? iconClasses : undefined}
              />
            </span>
            <span className={twMerge(labelClasses, { hidden: !label })}> {label || 'Home'}</span>
          </span>
        ) : (
          <span className={twMerge(breadcrumbTextOpt, labelClasses)}>{label}</span>
        )}
      </span>
    </ItemConditionalWrapper>
  );
}
